import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

/**
 * @name me
 * @description Get the profile of the current user
 * @param {string} token
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const me = async (token) => {
  apiClient.setAuthToken(token);
  const response = await apiClient.request('GET', '/admin/user/me');
  if (!isApiResponseError(response)) {
    return {
      ...response.data,
      ...validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name changeProfile
 * @description Change the profile of the current user (municipality and department)
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const changeProfile = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name changePassword
 * @description Change the password of the current user
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const changePassword = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me/change-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name changeMail
 * @description Change the email of the current user
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const changeMail = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me/change-email', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name changeName
 * @description Change the name of the current user
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const changeName = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me/change-name', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name changeFacility
 * @description Change the name of the current user
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const changeFacility = async (data) => {
  const response = await apiClient.request('PATCH', '/admin/user/me/change-facility', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
